import { render, staticRenderFns } from "./ShapeManager.vue?vue&type=template&id=0022231a&scoped=true&"
import script from "./ShapeManager.vue?vue&type=script&lang=js&"
export * from "./ShapeManager.vue?vue&type=script&lang=js&"
import style0 from "./ShapeManager.vue?vue&type=style&index=0&id=0022231a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0022231a",
  null
  
)

export default component.exports